export const BUILD_ID = "20230314.2";


// WEBPACK FOOTER //
// ./src/build-id.ts